<template>
  <div class="article">
    <div class="form-group">
        <label>
            {{ $t("Можно выбрать из добавленных ранее статей") }}
        </label>
        <div class="article_rows">
          <v-radio-group
            v-model="articleSelectedData"
          >
            <LawNormFormArticleItem
              class="article_rows-item"
              v-for="item in articles"
              :article-item="item"
              @change="changeArticle"
              @cancel="cancelArticle"
              :key="item.id"
              @remove="removeArticle"
            />
          </v-radio-group>
        </div>
    </div>
  </div>
</template>
<script>

import LawNormFormArticleItem from '@/components/law/LawNormFormArticleItem.vue';

export default {
  name: 'LawNormFormArticle',
  components: { LawNormFormArticleItem },
  props: {
    articles: {
      type: Array,
      required: true
    },
    selectArticle: {
      type: Number,
      default: null
    },
    page: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      articleSelectedData: null
    }
  },
  mounted () {
    this.articleSelectedData = this.selectArticle
    this.$forceUpdate()
  },
  methods: {
    removeArticle(articleId) {
      this.articles = this.articles.filter((item) => item.id != articleId);
    },

    changeArticle(article) {
      this.$emit('change', article)
    },

    cancelArticle() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss">
  .article_rows {
    display: flex;
    flex-direction: column;
    width: 100%;

    &-item {
      padding-top: 10px;
      display: flex;
      width: 100%;

      .v-label {
        padding: 0 !important;
      }

      &-pencil {
       cursor: pointer;
      }
    }
  }
</style>
